import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Segment d'API de la cible : cohorte de volaille, cohorte de poissons, bassin, troupeau, culture */
export type CibleTerrain = 'volaille' | 'pisciculture' | 'bassins' | 'troupeaux' | 'cultures';
export type EtatObservation = 'BON' | 'A_SURVEILLER' | 'PROBLEME';

export interface Observation {
  id?: number;
  clientRef?: string;
  fermeId?: number;
  date: string;
  heure?: string;
  etat: EtatObservation;
  note?: string;
  photos?: string[];
  cible?: string;
  cibleId?: number;
  cibleNom?: string;
  module?: string;
  etatLibelle?: string;
  photosRecues?: { id: number; nom: string }[];
  createdBy?: string;
  createdById?: string;
  createdAt?: string;
}

export interface PeseeEchantillon {
  id?: number;
  clientRef?: string;
  fermeId?: number;
  date: string;
  unite: 'g' | 'kg';
  poids?: number[];
  poidsTotal?: number;
  nombre?: number;
  note?: string;
  cibleNom?: string;
  poidsG?: number[];
  poidsTotalG?: number;
  moyenneG?: number;
  minG?: number;
  maxG?: number;
  ecartTypeG?: number;
  cvPct?: number;
  homogeneitePct?: number;
  precedenteDate?: string;
  precedenteMoyenneG?: number;
  precedenteSource?: string;
  evolutionG?: number;
  evolutionPct?: number;
  joursEcoules?: number;
  gainQuotidienG?: number;
  effets?: string[];
  createdBy?: string;
  createdById?: string;
  createdAt?: string;
}

/** Observation du jour et pesée d'échantillon (saisies de terrain, sans validation) */
@Injectable({ providedIn: 'root' })
export class ObservationsService {
  private readonly base = `${environment.BASE_URL}/api`;

  constructor(private http: HttpClient) {}

  observations(cible: CibleTerrain, id: number): Observable<Observation[]> {
    return this.http.get<Observation[]>(`${this.base}/${cible}/${id}/observations`);
  }

  ajouterObservation(cible: CibleTerrain, id: number, o: Observation): Observable<Observation> {
    return this.http.post<Observation>(`${this.base}/${cible}/${id}/observations`, o);
  }

  supprimerObservation(cible: CibleTerrain, observationId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${cible}/observations/${observationId}`);
  }

  pesees(cible: CibleTerrain, id: number): Observable<PeseeEchantillon[]> {
    return this.http.get<PeseeEchantillon[]>(`${this.base}/${cible}/${id}/pesees-echantillon`);
  }

  ajouterPesee(cible: CibleTerrain, id: number, p: PeseeEchantillon): Observable<PeseeEchantillon> {
    return this.http.post<PeseeEchantillon>(`${this.base}/${cible}/${id}/pesees-echantillon`, p);
  }

  supprimerPesee(cible: CibleTerrain, peseeId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${cible}/pesees-echantillon/${peseeId}`);
  }
}
